<script>
import Layout from '@layouts/primary'
import { binMethods } from '@state/helpers'
import parseDateMomentJS from '../../utils/format-date'
import ListLoading from '../../components/loading'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Equipments',
    meta: [{ name: 'description', content: 'Equipments' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      search: '',
      loadingData: true,
      binsSearch: '',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Capacity', value: 'capacity' },
        // { text: 'Price', value: 'price' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      binsHeaders: [
        // { text: 'Bin Id', value: 'bin_id' },
        { text: 'Client Name', value: 'service.client_id.client_name' },
        { text: 'Service Title', value: 'service.service_title' },
        { text: 'Service Type Name', value: 'service.service_type_id.name' },
        // { text: 'Service Description', value: 'service_description' },
        { text: 'Issue Date', value: 'dateSeconds' },
      ],
      binTypes: [],
      serviceBinsList: [],
      newBinType: {},
      binUpdate:{},
      binID: '',
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addBinType: false,
      deleteBinType: false,
      editBinType: false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    // let moment = require('moment');

    this.getBins().then(response => {
      let obj = this.$store.state.bins.objects
      for (let v in obj) {
        this.binTypes.push(obj[v])
      }
      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })
    this.loadingData=true
    this.serviceBins().then(response => {
      let obj = this.$store.state.bins.serviceObjects
      for (let v in obj) {
        // Only show bins that have services and client
        if(obj[v].service && obj[v].service.client_id){
          this.serviceBinsList.push(obj[v])
        }
      }
      let moment = require('moment');
      for(let i in this.serviceBinsList){
        // Create a copy of the object to update it
        let formattedObj = this.serviceBinsList;

        // let day = moment.unix(formattedObj[i].issue_date / 1000)
        // formattedObj[i].date = day.format('dddd, MMMM Do, YYYY h:mm A')

        formattedObj[i].date = parseDateMomentJS(formattedObj[i].issue_date);
        formattedObj[i].dateSeconds = moment(formattedObj[i].date).valueOf()
        this.serviceBinsList = formattedObj
      }
      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })

    // console.log(this.serviceBinsList)
  },
  methods: {
    ...binMethods,
    async submit() {
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          this.addBinType = false;
          this.createBin(this.newBinType).then( d => {
            location.reload()
          })
        }
      })
    },
    clear() {
      this.newBinType = {}
      this.$validator.reset()
      this.addBinType = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    editBin(props){
      // Create a copy of the object to update it
      let formattedObj = {
        ...props
      }

      this.binUpdate = formattedObj;
      this.editBinType = !this.editBinType
    },
    async update(binUpdate){
      await this.$validator.validateAll('form-bin').then(result => {
        // console.log(result)
        if(result) {
          this.updateBin(binUpdate).then(d => {
            location.reload()
          })
        }
      });
    },
    deleteCurrentBin(props){
      if(this.$store.getters['auth/getUserRole'] === 'Admin') {
        this.deleteBinType = !this.deleteBinType
        this.binID = props.id
      }
    },
    async performDelete(){
      await this.deleteBin({id:parseInt(this.binID)}).then(d => {
        location.reload()
      })
    }
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Bin Types
        </h2>
        <ListLoading :display="loadingData" />
        <VBtn
          v-if="!loadingData"
          slot="activator"
          :class="$style.addButton"
          color="blue"
          @click="addBinType = !addBinType"
        >
          + ADD BIN TYPE
        </VBtn>
      </div>

      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="binTypes"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.id }}
          </td>

          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.description }}
          </td>
          <td class="text-xs-left">
            {{ props.item.capacity }}
          </td>
          <!--<td class="text-xs-left">-->
          <!--$ {{ props.item.price }}-->
          <!--</td>-->

          <td class="justify-center layout px-0">
            <VIcon
              small
              class="mr-2"
              @click="editBin(props.item)"
            >
              edit
            </VIcon>
            <VIcon
              small
              @click="deleteCurrentBin(props.item)"
            >
              delete
            </VIcon>
          </td>
        </template>
      </VDataTable>
    </VContainer>


    <VContainer v-if="!loadingData">
      <div class="">
        <h2 :class="$style.routeHeader">
          Bins
        </h2>
      </div>

      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="binsSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="binsHeaders"
        :items="serviceBinsList"
        :search="binsSearch"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <!--<td-->
          <!--v-if="props.item.service"-->
          <!--class="text-xs-left"-->
          <!--&gt;-->
          <!--{{ props.item.bin_id }}-->
          <!--</td>-->

          <td
            v-if="props.item.service"
            class="text-xs-left"
          >
            {{ props.item.service.client_id.client_name }}
          </td>
          <td
            v-if="props.item.service"
            class="text-xs-left"
          >
            {{ props.item.service.service_title }}
          </td>
          <td
            v-if="props.item.service"
            class="text-xs-left"
          >
            {{ props.item.service.service_type_id.name }}
          </td>

          <!--<td-->
          <!--v-if="props.item.service"-->
          <!--class="text-xs-left"-->
          <!--&gt;-->
          <!--{{ props.item.service.service_type_id.description }}-->
          <!--</td>-->

          <td class="text-xs-left">
            {{ props.item.date }}
          </td>

        </template>
      </VDataTable>
    </VContainer>

    <!--EDIT MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="editBinType"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Edit Bin Type</h2>
              <VLayout
                wrap
                data-vv-scope="form-bin"
              >

                <VFlex
                  xs12
                >
                  <VTextField
                    v-model="binUpdate.name"
                    v-validate="'required'"
                    data-vv-scope="form-bin"
                    label="Name"
                    required
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                  />
                  <p
                    v-if="errors.has('form-bin.name')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-bin.name') }}
                  </p>
                </VFlex>

                <VFlex
                  xs12
                >
                  <VTextField
                    v-model="binUpdate.description"
                    label="Description"
                    data-vv-name="description"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="binUpdate.capacity"
                    v-validate="'required'"
                    data-vv-scope="form-bin"
                    label="Capacity"
                    required
                    :error-messages="errors.collect('capacity')"
                    data-vv-name="capacity"
                    type="number"
                  />
                  <p
                    v-if="errors.has('form-bin.capacity')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-bin.capacity') }}
                  </p>
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="binUpdate.itemcode"
                    v-validate="'required'"
                    data-vv-scope="form-bin"
                    label="Item Code"
                    required
                    :error-messages="errors.collect('itemcode')"
                    data-vv-name="itemcode"
                  />
                  <p
                    v-if="errors.has('form-bin.itemcode')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-bin.itemcode') }}
                  </p>
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="editBinType = !editBinType"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="update(binUpdate)"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <!-- ADD MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addBinType"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Add Bin Type</h2>
              <VLayout wrap>

                <VFlex
                  xs12
                >
                  <VTextField
                    v-model="newBinType.name"
                    v-validate="'required'"
                    label="Name"
                    required
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                  />
                </VFlex>

                <VFlex
                  xs12
                >
                  <VTextField
                    v-model="newBinType.description"
                    label="Description"
                    data-vv-name="description"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newBinType.capacity"
                    v-validate="'required'"
                    label="Capacity"
                    required
                    :error-messages="errors.collect('capacity')"
                    data-vv-name="capacity"
                    type="number"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newBinType.itemcode"
                    v-validate="'required'"
                    label="Item Code"
                    required
                    :error-messages="errors.collect('itemcode')"
                    data-vv-name="itemcode"
                  />
                  <!--<VTextField-->
                  <!--v-model="newBinType.price"-->
                  <!--v-validate="'required'"-->
                  <!--label="Price"-->
                  <!--required-->
                  <!--:error-messages="errors.collect('price')"-->
                  <!--data-vv-name="price"-->
                  <!--type="number"-->
                  <!--prefix="$"-->
                  <!--/>-->
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="clear()"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submit()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="deleteBinType"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to delete {{ binID }} ?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="deleteBinType = !deleteBinType"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="orange"
                    block
                    @click.native="performDelete()"
                  >
                    DELETE
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>


  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .routeHeader {
    display: inline-block;
  }

  .addButton {
    display: inline-block;
    float: right;
  }
</style>
